import { Helmet } from "react-helmet-async";
import ServicesSection from "../components/ServicesSection";

export default function ServicesPage() {
  return (
    <>
      <Helmet>
        <title>Services | Nexalus Infotech</title>
        <meta
          name="description"
          content="ELV turnkey solutions, ICT integration, CCTV, access control, fire alarm, and building management services from Nexalus Infotech."
        />
      </Helmet>
      <main className="pt-24">
        <ServicesSection />
      </main>
    </>
  );
}
